// extracted by mini-css-extract-plugin
export var skeletonAnimation = "index-module--skeleton-animation--021e2";
export var skeletonElement = "index-module--skeleton-element--a997a";